import React from 'react';
import Helmet from 'react-helmet';
import { withTranslation }  from 'react-i18next';
import { withRouter } from 'react-router';
import companyName from '../../../store/mobxStore/companyName';
import PageTitle from '../../components/common/pageTitle';
import {FaqContent} from '../../components/tools';



function Faqs(props){
    const {t} = props
    return (
      <div className="h-100">
          <Helmet>
              <title>{companyName.companyName} | {t('Sidemenu.faq')}</title>
          </Helmet>
          <PageTitle 
              title="faq"  
              buttonOn={false}  
          />
          <FaqContent />
      </div>
    )

}
export default withTranslation()(withRouter(Faqs))